import React from 'react';
import assertNever from 'shared/utils/assertNever';
import { useTranslation } from 'react-i18next';
import { TransferProgressStep } from '../TransferProgressStep/TransferProgressStep';
import {
  RequiredTasksWrapper,
  SectionTitle,
  TaskSection,
  EmptyStateBox,
} from './RequiredTasks.styles';

export enum TransferRequiredTaskState {
  NONE_REQUIRED = 'NoneRequired',
  UCC_FEE_DUE = 'UCCFeeDue',
  UCC_FEE_PAID = 'UCCFeePaid',
  PREPAYMENT = 'Prepayment',
  PAYOFF_PAYMENT = 'PayoffPayment',
}

interface TaskContentProps {
  task: TransferRequiredTaskState;
}

function RequiredTaskContent({ task }: TaskContentProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'support&FAQs.faqCategories.agreementTransferStatus.requiredTasks',
  });

  switch (task) {
    case TransferRequiredTaskState.NONE_REQUIRED:
      return <EmptyStateBox>{t('noRequiredSteps')}</EmptyStateBox>;
    case TransferRequiredTaskState.UCC_FEE_DUE:
      return (
        <TransferProgressStep
          status="active"
          title={t('adminFee.label')}
          titleHref="#" // TODO HOP-3160 Link
          statusText={t('adminFee.description')}
          bullets={[t('adminFee.bullet')]}
          nextStatus={null}
          hasPrev={false}
        />
      );
    case TransferRequiredTaskState.UCC_FEE_PAID:
      return (
        <TransferProgressStep
          status="complete"
          title={t('adminFee.label')}
          titleHref="#" // TODO HOP-3160 Link
          statusText={t('adminFee.completed')}
          nextStatus={null}
          hasPrev={false}
        />
      );
    case TransferRequiredTaskState.PREPAYMENT:
      return (
        <TransferProgressStep
          status="active"
          title={t('prepayment.label')}
          titleHref="#" // TODO HOP-3160 Link
          statusText={t('prepayment.description')}
          nextStatus={null}
          hasPrev={false}
        />
      );
    case TransferRequiredTaskState.PAYOFF_PAYMENT:
      return (
        <TransferProgressStep
          status="active"
          title={t('payoffPayment.label')}
          titleHref="#" // TODO HOP-3160 Link
          statusText={t('payoffPayment.description')}
          nextStatus={null}
          hasPrev={false}
        />
      );
    default:
      return assertNever(task);
  }
}

interface Props {
  task: TransferRequiredTaskState;
}

export function RequiredTasks({ task }: Props) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'support&FAQs.faqCategories.agreementTransferStatus.requiredTasks',
  });

  return (
    <RequiredTasksWrapper>
      <SectionTitle>{t('title')}</SectionTitle>
      <TaskSection>
        <RequiredTaskContent task={task} />
      </TaskSection>
    </RequiredTasksWrapper>
  );
}

export default RequiredTasks;
